import React from 'react';
import { bool, shape, string } from 'prop-types';

const ArrowUp = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5575 11.7802L9 8.34516L12.4425 11.7802L13.5 10.7227L9 6.22266L4.5 10.7227L5.5575 11.7802Z" fill="currentColor" />
  </svg>
);

ArrowUp.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ArrowUp;
